export enum OrientationEnum {
  VERTICAL,
  HORIZONTAL,
}

export enum DigitalMenuDataTypeEnum {
  IMAGES,
  VIDEO,
  TEMPLATE,
}
